import React from 'react';
import { Box } from '@common-fe/common-fe';

import { WarnModal } from '@/components/elements';
import { ModalWrapper } from '@/components/wrappers';
import BankInformationForm from '@/modules/employer/components/SetupEmployer/FinancialDetails/BankInformation/BankInformationForm';

import { useEmployerReactivationBankListModals } from './hooks/useEmployerReactivationBankListModals';

export const EmployerReactivationBankListModals: React.FC = () => {
  const {
    viewModalVisible,
    editModalVisible,
    addModalVisible,
    currentBank,
    isLoading,
    errorModal,
    errorModalProps,
    isErrorModalVisible,
    handleViewCancel,
    handleEditModalClose,
    handleEditCancel,
    handleAddModalClose,
    handleAddCancel,
    handleSubmit,
    handleAddSubmit,
    setShouldConfirmOnClose,
    setViewModalVisible,
    setEditModalVisible,
    setErrorModal,
    retry,
  } = useEmployerReactivationBankListModals();
  return (
    <>
      <Box
        data-testid="EmployerReactivationBankListModals"
        style={errorModal ? { display: 'none' } : {}}
      >
        <ModalWrapper
          testId="EmployerReactivationBankList_view-modal"
          visible={viewModalVisible}
          title="View Bank Account"
          onSetVisible={handleViewCancel}
          isClosingByClickOutsideBlocked
        >
          {currentBank && (
            <BankInformationForm
              defaultValues={currentBank}
              viewMode
              loading={isLoading}
              onDirty={() => null}
              onSetEditMode={() => {
                setViewModalVisible(false);
                setEditModalVisible(true);
              }}
            />
          )}
        </ModalWrapper>

        <ModalWrapper
          testId="EmployerReactivationBankList_edit-modal"
          visible={editModalVisible}
          title="Edit Bank Account"
          onSetVisible={handleEditModalClose}
          isClosingByClickOutsideBlocked
        >
          {currentBank && (
            <BankInformationForm
              loading={isLoading}
              bankEditMode
              defaultValues={currentBank}
              onDirty={setShouldConfirmOnClose}
              onSubmit={handleSubmit}
              onCancel={handleEditCancel}
            />
          )}
        </ModalWrapper>

        <ModalWrapper
          testId="EmployerReactivationBankList_add-modal"
          visible={addModalVisible}
          title="Add Bank Account Details"
          onSetVisible={handleAddModalClose}
          isClosingByClickOutsideBlocked
        >
          <BankInformationForm
            loading={isLoading}
            onDirty={setShouldConfirmOnClose}
            onSubmit={handleAddSubmit}
            onCancel={handleAddCancel}
          />
        </ModalWrapper>
      </Box>

      {isErrorModalVisible && (
        <WarnModal
          onSetVisible={setErrorModal}
          {...errorModalProps}
          onSubmit={retry}
        />
      )}
    </>
  );
};
